import { render, staticRenderFns } from "./servicos.vue?vue&type=template&id=9d0b21b8&scoped=true&"
import script from "./servicos.vue?vue&type=script&lang=js&"
export * from "./servicos.vue?vue&type=script&lang=js&"
import style0 from "./servicos.vue?vue&type=style&index=0&id=9d0b21b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0b21b8",
  null
  
)

export default component.exports